import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=efb773f0&"
import script from "./spinner.ts?vue&type=script&lang=js&"
export * from "./spinner.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports